import { render, staticRenderFns } from "./iconCancel.vue?vue&type=template&id=35f13882&"
import script from "./iconCancel.vue?vue&type=script&lang=js&"
export * from "./iconCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports